import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { setViewBulletinUploadForm } from "features/bulletin/bulletinSlice";
import UploadBulletinModal from "components/bulletin/UploadBulletinModal";
import BulletinFeed from "components/bulletin/BulletinFeed";
import BulletinFile from "components/bulletin/BulletinFile";
import CreateButton from "components/buttons/CreateButton";
import { Modal } from "@mui/material";
import { MUIModalWrap } from "components/modal/modal.styled";
import { setViewConfirmModal } from "features/modal/modalSlice";
import ConfirmModal from "components/modals/ConfirmModal";
import { MobilePageTitle } from "components/main.styled";

import SectionHelp from "components/help/SectionHelp";
import { useTranslation } from "react-i18next";

export default function Bulletin() {
  const { t: translate } = useTranslation();
  const { user } = useSelector((state) => state.auth);
  const { profileChurch } = useSelector((state) => state.profileChurch);
  const {
    viewBulletinUploadForm,
    viewBulletinFileInModal,
    currentBulletinFileView,
    isDeleteBulletinLoading,
    isDeleteBulletinSuccess,
  } = useSelector((state) => state.bulletin);
  const dispatch = useDispatch();
  const [isUserAdmin, setIsUserAdmin] = useState(false);

  const { confirmModalData, viewConfirmModal } = useSelector(
    (state) => state.modal,
  );

  const handleUploadBulletin = () => {
    dispatch(setViewBulletinUploadForm(true));
  };

  useEffect(() => {
    if (profileChurch) {
      setIsUserAdmin(profileChurch.admins.includes(user._id));
    }
  }, [profileChurch, user._id]);

  return (
    <BulletinContainer>
      <MobilePageTitle>{translate("web:bulletin.bulletins")}</MobilePageTitle>

      {(user.isChurch || user.isOrganization || isUserAdmin) && (
        <HeaderActions>
          <CreateButton
            handler={handleUploadBulletin}
            buttonText={translate("web:bulletin.uploadBulletin")}
          />
          <SectionHelp
            title={translate("church:bulletins.title")}
            intro="The bulletin library gives members one dependable place to find the documents shared by your church."
            options={[
              {
                title: "Upload a bulletin",
                description:
                  "Add a digital copy of a service bulletin or church publication so members can open or download it later.",
                bestFor:
                  "Weekly service bulletins, newsletters, ministry guides, and recurring church publications.",
                features: [
                  "Preserves an accessible history",
                  "Reduces dependence on printed copies",
                  "Makes files easy to find again",
                ],
              },
            ]}
            footer="Use a clear date and descriptive filename before uploading so members can recognize the correct bulletin."
          />
        </HeaderActions>
      )}

      <BulletinFeed />

      {viewBulletinFileInModal && (
        <BulletinFile file={currentBulletinFileView} />
      )}

      <Modal
        open={viewBulletinUploadForm}
        onClose={() => dispatch(setViewBulletinUploadForm(false))}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MUIModalWrap>
          <UploadBulletinModal />
        </MUIModalWrap>
      </Modal>

      {/* {
            viewDeleteFileModal && (
               <DeleteFileModal />
            )
        }
 */}
      <Modal
        open={viewConfirmModal}
        onClose={() => dispatch(setViewConfirmModal(false))}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MUIModalWrap>
          <ConfirmModal
            text={confirmModalData.text}
            handler={confirmModalData.handler}
            confirmBtnBackgroundHover={
              confirmModalData.confirmBtnBackgroundHover
            }
            extraInfo={confirmModalData.extraInfo}
            doSomethingAfterClose={false}
            loadingState={isDeleteBulletinLoading}
            conditionToCloseModal={isDeleteBulletinSuccess}
          />
        </MUIModalWrap>
      </Modal>
    </BulletinContainer>
  );
}

const BulletinContainer = styled.div`
  width: 100%;
  padding: 10px;
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 0;
`;
